import { Injectable, isDevMode } from '@angular/core';
import * as authentification from '@oel/js-authentification';
import { ConfigurationService } from '@oel/js-configuration';

@Injectable({
  providedIn: 'root'
})
export class Auth0Service {
  static isInitialise: boolean;
  tokenMockeur = ConfigurationService.getConfig('web-spa-jwt-mockeur');

  constructor() {}

  async initialiser() {
    if (Auth0Service.isInitialise) {
      console.warn('Auth0 est déjà initialisée');
      return;
    }
    if (!this.tokenMockeur) {
      authentification.initialiser();
      Auth0Service.isInitialise = true;
    }
  }
}
